import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import TimelineIcon from '@mui/icons-material/Timeline';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import LogoutButton from './LogoutButton';


const SideBarItems = {
    'timeLine' : <TimelineIcon />,
    'currentStock' : <BarChartIcon />
}

const SideBarTitles = {
    'timeLine' : 'Tarieven Tijdlijn',
    'currentStock' : 'Huidige voorraad'
}


const SideBar = ({setChartPage}) => {


    const [mousePos, setMousePos] = useState({});

    useEffect(() => {
      const handleMouseMove = (event) => {
        setMousePos({ x: event.clientX, y: event.clientY });
      };
  
      window.addEventListener('mousemove', handleMouseMove);
    }, []);
    

    useEffect(() => {

        if (mousePos.x > 250){
            setState(false)
        }
    }, [mousePos])


  const [state, setState] = useState(false)

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={() => setState(false)}
      onKeyDown={() => setState(false)}
    >
        <List>
            {Object.keys(SideBarItems).map((text, index) => (
                <ListItem key={text} disablePadding>
                    <ListItemButton 
                    onClick={() => setChartPage({[text]: true})}
                    >
                        <ListItemIcon>
                            {SideBarItems[text]}
                        </ListItemIcon>
                        <ListItemText primary= {SideBarTitles[text]} />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    </Box>
  );

  return (
    <div style={{ 
        position: 'absolute',
        left: '15px',
        top: '15px'
        }}>
        <IconButton onClick={() => setState(true)} onMouseOver={() => setState(true)}>
            <MenuIcon />
        </IconButton>
        <Drawer
            anchor={'left'}
            open={state}
            onClose={() => setState(false)}
        >
            {list()}
            <LogoutButton />
        </Drawer>
    </div>
  );
}

export default SideBar